import {css} from "styled-components";

export const StockTransferPopupStyled = css`
  .stock-transfer-popover {
    width: 270px;

    .ant-popover-content .ant-popover-inner .ant-popover-inner-content {
      height: 180px;
      margin: 0 -12px;
      overflow: auto;

      .container {
        display: flex;
        width: 100%;

        .text-container {
          flex: 1;
          min-width: 0;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;

          .name {
            font-weight: 400;
            color: #00000080;
          }
        }

        .qty {
          min-width: 40px;
          margin-left: 10px;
          text-align: right;
        }
      }
    }
  }
`;
